(function() {
    angular
        .module("app")
        .directive("loader", loader)

    loader.$inject = [
        "$http",
        "$timeout"
    ]

    function loader(
        $http,
        $timeout
    ){
        return {
            restrict: "A",
            replace: false,
            transclude: true,
            templateUrl: "app/directives/loader.view.html",
            link: function(scope, elm, attrs) {
                scope.loader_gif_type = "dark"
                elm.addClass("loader-container")

                if (attrs.loader == "full") {
                    elm.removeClass("loader-container")
                    elm.children().first().addClass("loader-full")
                    scope.loader_gif_type = "light"
                }

                scope.isLoading = function() {
                    if ($http.pendingRequests.length === 1) {
                        return $http.pendingRequests[0].data === undefined || $http.pendingRequests[0].data.preferences === undefined
                    }
                    return $http.pendingRequests.length > 0
                }

                scope.$watch(scope.isLoading, function(v) {
                    if (v){
                        scope.loader = true
                    } else {
                        $timeout(function() {
                            scope.loader = false
                        }, 1000)
                    }
                })
            }
        }
    }
})()
